import PagoAutomaticoTarjetasPanel from '@/components/settings/pago-automatico-tarjetas/PagoAutomaticoTarjetasPanel';

export default function PagoAutomaticoTarjetasPage() {
  return <PagoAutomaticoTarjetasPanel />;
}
